import { useCallback } from 'react';
import { useNavigate } from 'react-router';

import { useUserData } from '../../../redux/selectors';

import useRefreshUser from './useRefreshUser';

// A notification can announce an onboarding decision the portal hasn't loaded yet. Refresh
// the user first, or AppLayout redirects using the stale status (e.g. back to /onboarding/pending).
const useNotificationNavigate = (): ((target: string) => Promise<void>) => {
  const navigate = useNavigate();
  const refreshUser = useRefreshUser();
  const { onboardingStatus } = useUserData();

  return useCallback(
    async (target: string): Promise<void> => {
      if (onboardingStatus && onboardingStatus !== 'onboarded') {
        await refreshUser();
      }

      void navigate(target);
    },
    [navigate, onboardingStatus, refreshUser]
  );
};

export default useNotificationNavigate;
